module.exports = __webpack_public_path__ + "img/titlelogo.41219bc6.png";